export const BANKS = {
  100: 'Maybank',
  101: 'Public Bank',
  102: 'CIMB Bank',
  103: 'Hong Leong',
  104: 'RHB',
  105: 'AmBank',
  106: 'KBank',
  107: 'Bankok Bank',
  108: 'SCB',
  109: 'Krung Thai',
  110: 'Ayudhya',
  111: 'GSBank',
  112: 'TMB Bank',
  113: 'CIMB Thai',
  114: 'Kiatnakin',
  115: 'Techcombank',
  116: 'Sacombank',
  117: 'Vietcombank',
  118: 'ACB',
  119: 'DongA Bank',
  120: 'VietinBank',
  121: 'BIDV',
  122: 'Eximbank',
  123: 'BCA',
  124: 'BNI',
  125: 'BRI',
  126: 'Mandiri Bank',
  127: 'CIMB',
  128: 'VPBank',
  129: 'MBBank',
  130: 'TPBank',
  131: 'Agribank',
  132: 'LienVietPostBank',
  133: 'SHBANK',
  134: 'PVcombank',
  135: 'SAIGON BANK',
  136: 'SeABank',
  137: 'ABBANK',
  138: 'BAC A BANK',
  139: 'Viet Capital Bank',
  140: 'MSB',
  141: 'Kienlongbank',
  142: 'NamABank',
  143: 'NCB',
  144: 'HDBank',
  145: 'OCB',
  146: 'VIB',
  147: 'SCB',
  148: 'Saigonbank',
  149: 'VietABank',
  150: 'BAOVIETBank',
  151: 'Vietbank',
  152: 'PG Bank',
  1000: 'All banks support'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js